export default __webpack_public_path__ + "assets/img/plants_1.jpg";